module.exports = __webpack_public_path__ + "static/media/家居门店数字化管理.b970f654.png";